<template>
    <section class="beerHeader">
      <h2>Reviews</h2>
      <button v-on:click="newReview(this.paramsId)" v-show="loggedIn === true && brewerStatus===false" class="button">Add Review</button>
    </section>
    <div v-for="review in reviews" v-bind:key="review.reviewId" class="review">
      <article>
        <div class="review-info">
          <h4>{{ review.username }} <i 
                class="fa-solid fa-star"
                v-for="n in review.rating"
                v-bind:key="n"
              ></i></h4>
          <p>{{ review.reviewText }}</p>
        </div>
      </article> 
      
    </div>
</template>
<script>

export default {
    name: "review-list",
    data() {
        return {
            loggedIn: this.$store.state.loggedIn,
            brewerStatus: this.$store.state.brewerStatus,
            paramsId: parseInt(this.$route.params.id),
        }
    },
    methods: {
        newReview(id) {
            this.$router.push(`/newReview/${id}`);
        }
    },
    computed: {
        reviews () {
            return this.$store.getters.getReviewsByBeerId(this.paramsId)
        }
    }
}
</script>
